import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as debug from 'src/app/shared/services/debug.service';
import { from, of } from 'rxjs';
import { switchMap, take, catchError } from 'rxjs/operators';
import { appUrl } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { delay } from 'src/app/shared/utils/utility.common';

const TWO_SECONDS = 2000;
@Component({
	selector: 'app-checkout-redirect-callback',
	templateUrl: './checkout-redirect-callback.component.html',
	styleUrls: ['./checkout-redirect-callback.component.scss']
})
export class CheckoutRedirectCallbackComponent implements OnInit, AfterViewInit {
	message = 'Verifying checkout..';

	constructor(private readonly securityService: SecurityService
		, private router: Router
		, private activedRoute: ActivatedRoute
	) { }

	ngOnInit(): void {
	}

	async ngAfterViewInit(): Promise<any> {
		const securityServiceIsLoggedIn = await this.securityService.isLoggedIn('015 CheckoutRedirectCallback ngAfterViewInit');
		debug.log(`067.2 CheckoutRedirectCallback loggedIn: ${securityServiceIsLoggedIn}`);
		if (!securityServiceIsLoggedIn) {
			debug.log(`067.3 CheckoutRedirectCallback trying to login...`);
			// let SigninRedirectCallbackComponent handle the checking of checkout data
			// await delay(TWO_SECONDS);
			return await this.securityService.login();
		} else {
			debug.log(`067.4 CheckoutRedirectCallback redirecting to trackinator/parcels..`);

			// TODO: extract query string and loop to check if the trackinator api webhook
			// has already finish processing the checkout event
			// url:http://localhost:4200/checkout-redirect?hostedpage=b1d6f3a5fd2ccd03b4110a74c2431723:82232bd07beb8a892cd7cd79088c8d95c27085a77ea181b22467ae95916869c66db6e9d23188edc90a5de92cdbff96d0a3eff71a83a09f0c5600dc25ffc5325f257b9a0f52d543a1c567753bc119c384d4622af86b41891978dfef68d204bcdbfd2e48a0fc27411d48bbe3398e0b6c069724405b04577308b205b0562331c05626459c9f6fbe4791f0013550a7e60857
			// await delay(TWO_SECONDS);

			this.message = `Verifying checkout data..`;

			const hostedpage = this.activedRoute.snapshot.queryParamMap.get('hostedpage');

			return this.securityService.verifyCheckoutResponse(hostedpage, `067.0 SigninRedirectCallbackComponent`)
				.pipe(
					switchMap(verifyCheckoutResponse => {
						// Pre-load user profile for optimization purposes.
						this.message = `Loading profile..`;
						return this.securityService.getUserProfile(appUrl.userProfile, `067.1 SigninRedirectCallbackComponent`);
					}))
				.subscribe(profile => {
					this.router.navigate(['/trackinator/parcels'], { replaceUrl: true });
				});

			// this.message = `Loading profile..`;
			// await delay(TWO_SECONDS);

			// return this.securityService.getUserProfile(appUrl.userProfile, `067.1 SigninRedirectCallbackComponent`)
			//     .subscribe(profile => {
			//         this.router.navigate(['/trackinator/parcels'], { replaceUrl: true });
			//     });
		}
	}
}
